import styled from 'styled-components';

export const HomeContainer = styled.div``;

export const Mission = styled.section`
  padding: 80px 0;
  text-align: center;
  
  h2 {
    color: ${({ theme }) => theme.colors.primary};
    font-size: 2.5rem;
    margin-bottom: 2rem;
  }
  
  p {
    max-width: 800px;
    margin: 0 auto;
    font-size: 1.2rem;
    line-height: 1.8;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const Stats = styled.section`
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  padding: 60px 0;
  
  .container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
    text-align: center;
  }
`;

export const StatItem = styled.div`
  h3 {
    font-size: 2.5rem;
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme.colors.secondary};
  }
  
  p {
    font-size: 1.1rem;
  }
`;

